import React from 'react';
import useOptimizedConfig from '@/hooks/useOptimizedConfig';
import {ChartType, csvDownloadableTypes} from '@/views/storyboard/utils/chartConstants';
import {Dropdown} from 'react-bootstrap';
import {useStoreState} from 'store';
import i18n from 'i18n';
import Icon from '@/components/icons/Icon';
import {hasPermission} from '@/utils/permissions/permissionDebug';

interface Props {
    chartId?: number;
    chartType: ChartType;
}

const ChartSettingsCSVDownloadButton = React.memo<Props>((
    {
        chartId = null,
        chartType
    },
) => {
    const chartDownloadCallbacks = useStoreState((state) => state.tableChartDownloadCallbacks.callbacks);

    const {userData, loading: loadingUserData} = useOptimizedConfig();


    // Early return conditions
    if (!csvDownloadableTypes.includes(chartType)) {return null;}
    if (loadingUserData || !hasPermission('fs.search.result.download', userData?.permissions, true)) {return null;}
    if (chartId === null || !chartDownloadCallbacks[chartId]) {return null;}

    const downloadCallback = chartDownloadCallbacks[chartId];

    return (
        <Dropdown.Item
            onClick={downloadCallback}
            data-cy="chart-settings-download-csv-button"
        >
            <Icon name="mdi-export" className="mr-2"/> {i18n.t('jt_download_csv.text')}
        </Dropdown.Item>
    );
});

export default ChartSettingsCSVDownloadButton;
